import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.css']
})
export class LoadingDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LoadingDialogComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: IFileUploadDialog
  ) { }

  onConfirm(event: MouseEvent): void {
    this.dialogRef.close(true);
    event.preventDefault();
  }

  onCancel(event: MouseEvent): void {
    this.dialogRef.close(false);
    event.preventDefault();
  }

  ngOnInit() {
  }

}
